/* eslint-disable react/require-default-props */
/* eslint-disable no-unused-expressions */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import * as Routes from '@constants/routes';
import { Modal, CardBalances } from 'fpay-ui';
import { useAdvancements, useAuth } from '@hooks';
import { moneyFormat } from '@helpers';
import { isAllowed } from '@helpers/auth';
import { AdvancementModal } from '@components';
import { useBreakpoints } from '@hooks/NewBreakpoint';
import TycWarning from '../TycWarning';

const TextModal = styled.p`
  font-family: Roboto;
  text-align: left;
  color: #444b62;
  line-height: 21px;
  font-size: 16px;
  padding-left: 12px;
  padding-right: 12px;
  letter-spacing: 0px;
  margin: 18px 0px 24px;
  ${({ theme }) => theme.newBreakpoint('sm')} {
    line-height: 20px;
  }
`;

const BoxTyC = styled.div`
  display: flex;
  width: 100%;
  max-width: 800px;
`;

const MoneyResume = ({
  bankAccount,
  availableIncome,
  settledIncome,
  viewWithdrawMoney,
  htmlIdButton = 'unidentified-id',
  viewAdvancementButton,
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const foundsTyC = isAllowed('FOUNDS_TC_ENABLED');
  const {
    isTCMsg,
    isLegalAgent,
    merchant: { auto_cashout: autoCashout },
  } = useAuth();
  /** Se agrega null en useAndes para cortar request innecesarias */

  const { isSeller, isAlianzaMixto } = useAuth();

  const [showTooltipModal, setShowTooltipModal] = useState(false);
  const toggleModal = () => {
    setShowTooltipModal(!showTooltipModal);
  };
  const [showTooltipModal2, setShowTooltipModal2] = useState(false);
  const toggleModal2 = () => {
    setShowTooltipModal2(!showTooltipModal2);
  };

  const [showTycWarning, setShowTycWarning] = useState(false);
  const toggleTycWarning = () => {
    setShowTycWarning(!showTycWarning);
  };

  const handleRetirar = () => history.push(Routes.DO_FUNDS_OUT);
  const isValidateTC = isTCMsg();

  const { breakpoint } = useBreakpoints();

  const { getIdBackground, updateAdvancementStatus } = useAdvancements();

  const [showAdvancementModal, setShowAdvancementModal] = useState(false);

  const toggleShowAdvancementModal = () => {
    updateAdvancementStatus();
    setShowAdvancementModal(!showAdvancementModal);
  };

  const settledIncomeAvaliable = () => settledIncome > 0;

  useEffect(() => {
    !isValidateTC && foundsTyC && setShowTycWarning(!isValidateTC);
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {foundsTyC && showTycWarning && !isLegalAgent() && (
        <BoxTyC>
          <TycWarning closeWarning={toggleTycWarning} />
        </BoxTyC>
      )}
      <CardBalances
        firstBalanceTitle={t('paymentsFoundsOut.common.balanceToBeSettled')}
        firstBalanceTitleTooltip={
          isSeller() || isAlianzaMixto()
            ? t('tooltipCards.sellerCalendarFondsOutToLiquidate')
            : t('tooltipCards.merchantCalendarFondsOutToLiquidate')
        }
        firstAmount={moneyFormat(settledIncome)}
        viewFirstButton={viewAdvancementButton}
        disableFirstButton={!settledIncomeAvaliable()}
        firstButtonText={t('paymentsFoundsOut.common.buttonRequestMoneyAdvance')}
        firstButtonHtmlId={
          settledIncomeAvaliable() ? 'advance-withdrawal-OK-btn' : 'advance-withdrawal-NOK-btn'
        }
        handleFirstBalanceButtonClick={() => setShowAdvancementModal(true)}
        secondBalanceTitle={t('homeScreen.totalBalance.title')}
        secondBalanceTitleTooltip={
          isSeller() || isAlianzaMixto()
            ? t('tooltipCards.sellerCalendarFondsOutBalanceAvailable')
            : t('tooltipCards.merchantCalendarFondsOutBalanceAvailable')
        }
        secondAmount={moneyFormat(availableIncome)}
        viewSecondButton={viewWithdrawMoney && !autoCashout}
        disableSecondButton={
          !(availableIncome > 0) ||
          moneyFormat(availableIncome) === '$0' ||
          !bankAccount ||
          (foundsTyC && !isValidateTC && !isLegalAgent())
        }
        secondButtonText={t('paymentsFoundsOut.common.buttonFoundsOut')}
        secondButtonHtmlId={htmlIdButton}
        handleSecondBalanceButtonClick={handleRetirar}
      />
      {showTooltipModal && (
        <Modal fClose={toggleModal}>
          <TextModal>{t('homeScreen.cards.toLiquidate')}</TextModal>
        </Modal>
      )}
      {showTooltipModal2 && (
        <Modal fClose={toggleModal2}>
          <TextModal>{t('homeScreen.totalBalance.description')}</TextModal>
        </Modal>
      )}
      {showAdvancementModal && (
        <Modal
          htmlIdBackground={getIdBackground()}
          showCloseButton={false}
          fClose={toggleShowAdvancementModal}
          width={breakpoint === 'xs' ? '328px' : '504px'}
          paddingLeft="0"
          paddingRight="0"
        >
          <AdvancementModal
            handleCancel={() => toggleShowAdvancementModal()}
            liquidationAmount={settledIncome}
          />
        </Modal>
      )}
    </>
  );
};

export default MoneyResume;

MoneyResume.propTypes = {
  bankAccount: PropTypes.any.isRequired,
  availableIncome: PropTypes.number.isRequired,
  settledIncome: PropTypes.number.isRequired,
  viewWithdrawMoney: PropTypes.bool,
};
